import {LOAD_CONNECTIVITYSTATE_COMPLETE, LOAD_CONNECTIVITYSTATE_ERROR, LOAD_CONNECTIVITYSTATE_START, LOAD_CONNECTIVITYSTATE_SUCCESS} from './actions';
import {createResourceReducer} from 'src/shared/utils/resource';

export const connectivityState = createResourceReducer({
  start: LOAD_CONNECTIVITYSTATE_START,
  success: LOAD_CONNECTIVITYSTATE_SUCCESS,
  error: LOAD_CONNECTIVITYSTATE_ERROR,
  complete: LOAD_CONNECTIVITYSTATE_COMPLETE,
});
